import styled from 'styled-components';
import Calendar from 'react-calendar';
import { Calendar as CalendarIcon } from 'react-feather';

import { Row } from 'components/shared/Layout';

import { LinkButton } from 'components/ui/Button';
import ButtonGroup from 'components/ui/ButtonGroup';
import { ButtonContent } from 'components/ui/Button/Button.styles';

import { colours } from 'themes/default';

export const StyledUserDetails = styled(Row)`
  padding: 16px;
  background: ${colours.Greyscale.MistGrey};
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
  font-size: 16px;
  span {
    font-weight: bold;
  }
`;

export const StyledDate = styled.div`
  font-size: 18px;
  margin: 10px 0 32px;
`;

export const StyledCalendar = styled(Calendar)`
  .react-calendar__tile-away-dates {
    background-color: rgba(0, 110, 220, 0.5);
  }
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  margin-right: 5px;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  button {
    width: 140px;
  }
`;

export const StyledLinkButton = styled(LinkButton)`
  color: ${colours.Shades.BlueShade40};

  ${ButtonContent} {
    > :first-child {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
`;

export const InfoMessage = styled.div`
  color: ${colours.Greyscale.CharcoalGrey};
  background-color: ${colours.Greyscale.SilverGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  text-align: center;
  border-radius: 0.25rem;
  padding: 0.75rem 1.25rem;
  margin: 1.25rem 0;
`;

export const StyledCalendars = styled.div`
  display: flex;

  > :first-child {
    margin-right: 10px;
  }
`;

export const StyledLabel = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`;
